const PageBlockContentTypes = {
  VERTICAL_TILE: 'Vertical Tile',
  SIMPLE_COLUMN: 'Simple Column',
} as const;

export type PageBlockContentType =
  (typeof PageBlockContentTypes)[keyof typeof PageBlockContentTypes];

export default PageBlockContentTypes;
